export const GET_CAREER_MEDIAS = "GET_CAREER_MEDIAS";
export const GET_CAREER_MEDIUM_BY_ID = "GET_CAREER_MEDIUM_BY_ID";
export const UPDATE_CAREER_MEDIUM = "UPDATE_CAREER_MEDIUM";
export const DELETE_CAREER_MEDIUM = "DELETE_CAREER_MEDIUM";
export const CREATE_CAREER_MEDIUM = "CREATE_CAREER_MEDIUM";
